import { render, staticRenderFns } from "./TextContentQuestionType.vue?vue&type=template&id=eca6de50&scoped=true"
import script from "./TextContentQuestionType.vue?vue&type=script&lang=ts&setup=true"
export * from "./TextContentQuestionType.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./TextContentQuestionType.vue?vue&type=style&index=0&id=eca6de50&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eca6de50",
  null
  
)

export default component.exports